import React from 'react';

import {
  SongMetricItem,
  SongMetricsContainer,
  SongMetricUnit,
  SongMetricValue
} from '../../styles/SongMetrics.styled';
import {} from '../../styles/TrackPresentation.styled';

type SongMetricsProps = {
  releaseDate: string;
  genre: string;
  duration: string;
};

export const SongMetrics = ({
  releaseDate,
  genre,
  duration
}: SongMetricsProps) => {
  return (
    <SongMetricsContainer>
      <SongMetricItem>
        <SongMetricUnit>Release date</SongMetricUnit>
        <SongMetricValue>{releaseDate}</SongMetricValue>
      </SongMetricItem>
      <SongMetricItem>
        <SongMetricUnit>genre</SongMetricUnit>
        <SongMetricValue>{genre}</SongMetricValue>
      </SongMetricItem>
      <SongMetricItem>
        <SongMetricUnit>duration</SongMetricUnit>
        <SongMetricValue>{duration}</SongMetricValue>
      </SongMetricItem>
    </SongMetricsContainer>
  );
};
